module.exports = __webpack_public_path__ + "img/zhoubao.ad669454.png";